import { render } from "./UESocialHelpListView.vue?vue&type=template&id=6a31a672&scoped=true"
import script from "./UESocialHelpListView.vue?vue&type=script&lang=js"
export * from "./UESocialHelpListView.vue?vue&type=script&lang=js"

import "./UESocialHelpListView.vue?vue&type=style&index=0&id=6a31a672&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a31a672"]])

export default __exports__